export const BranchFilterOptionType = {
  Uncoded: "uncoded",
} as const;
export type BranchFilterOptionType =
  (typeof BranchFilterOptionType)[keyof typeof BranchFilterOptionType];
